<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6275)">
<rect x="8.7" y="0.7" width="20.6" height="28.6" rx="2.8" stroke="currentColor" stroke-width="1.6"/>
<rect x="15.5" y="4.5" width="7" height="1.4" rx="0.7" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2229_6275">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
